import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { isEmpty } from "lodash";
import { createErrorSelector, createLoadingSelector } from "store/selectors";
import { employerConstants } from "actions/types";
import {
  hasEnabledPayrollIntegration,
  hasStatePlanSelector,
} from "store/selectors/employer";
import type { RootState } from "types/state";

import EmployeeInvitationsTable from "./EmployeeInvitationsTable";
import AddEmployeeForm from "./AddEmployeeForm";
import IconSpinner from "components/IconSpinner";
import MissingEmployerGroup from "./MissingEmployerGroup";

import "./Employees.scss";

const actions = [
  employerConstants.GET_EMPLOYER_GROUPS,
  employerConstants.GET_EMPLOYEE_INVITES,
];
const isFetchingSelector = createLoadingSelector(actions);

const errorSelector = createErrorSelector(actions);
const mapStateToProps = (state: RootState) => {
  return {
    isFetching: isFetchingSelector(state),
    groups: state.employer.groups,
    employeeInvitations: state.employer.employeeInvitations,
    error: errorSelector(state),
    hasStatePlan: hasStatePlanSelector(state),
    hasPayrollIntegration: hasEnabledPayrollIntegration(state),
  };
};

const connector = connect(mapStateToProps);

type Props = WithApolloClient<ConnectedProps<typeof connector>>;

class Employees extends React.Component<Props> {
  componentDidMount() {
    window.analytics.page("Employer User Management");
  }

  render() {
    if (this.props.isFetching) {
      return <IconSpinner centered />;
    } else if (isEmpty(this.props.groups)) {
      return <MissingEmployerGroup />;
    } else if (
      isEmpty(this.props.employeeInvitations) &&
      !this.props.hasStatePlan &&
      !this.props.hasPayrollIntegration
    ) {
      return (
        <>
          <AddEmployeeForm />
        </>
      );
    }

    return (
      <div
        className="tab-pane"
        id="account employees-page"
        role="tabpanel"
        aria-labelledby="account_tab"
      >
        <EmployeeInvitationsTable
          // @ts-expect-error hasPayrollIntegration is supplied by EmployeeInvitationsTable's own mapStateToProps; this parent-passed value is inert (store wins) — preserved from the original JS.
          hasPayrollIntegration={this.props.hasPayrollIntegration}
        />
      </div>
    );
  }
}

export default connector(withApollo<Props>(Employees));
